
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getData = {
  getAllData(params) {
    return axios.post(
      `/api/admin/index/data`,
      qs.stringify(params)
    );
  },
  getEchartsData(params) {
    return axios.post(
      `/api/admin/index/echarts`,
      qs.stringify(params)
    );
  },
};
export default getData;
